import { LoadingState } from '../types';
function getFetchedDataPayload(fetchedData, defaultValue) {
    return (fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.loadingState) === LoadingState.Success ? fetchedData.payload : defaultValue;
}
export { getFetchedDataPayload };
//# sourceMappingURL=get-fetched-data-payload.js.map